/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarTeam = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6.998 2v2h-5v18H6v-.526c0-.484.052-.981.166-1.474H3.998V6h3v2h2V6h6v2h2V6h3v3h2V4h-5V2h-2v2h-6V2z" />
        <path d="M8.096 15a4.93 4.93 0 0 0 .536 1.466 5.936 5.936 0 0 0-.696.532L7.933 17H7v-2zm0-2a4.91 4.91 0 0 1 .883-2H7v2zm9.687 2.49c.084.006.17.01.256.01 1.638 0 3-1.266 3-3s-1.362-3-3-3c-.697 0-1.343.229-1.857.626.518.421.95.947 1.263 1.552a1.03 1.03 0 0 1 .594-.178c.571 0 1 .409 1 1s-.429 1-1 1c-.021 0-.042 0-.063-.002a5.13 5.13 0 0 1-.194 1.991zm.281 1.508c.307.273.573.566.8.873.758.106 1.243.35 1.543.617.388.344.593.837.593 1.486v.526h2v-.526c0-1.097-.366-2.183-1.264-2.981-.884-.786-2.153-1.177-3.736-1.177a9 9 0 0 0-.33.006 4.89 4.89 0 0 1-.302.644c.242.158.475.335.696.532zM12.942 10.5c-1.638 0-3 1.266-3 3s1.362 3 3 3c1.637 0 3-1.266 3-3s-1.363-3-3-3zm-1 3c0-.591.428-1 1-1s1 .409 1 1-.429 1-1 1-1-.409-1-1zM10 21.474c0-.649.205-1.142.593-1.486.402-.357 1.132-.672 2.407-.672s2.006.315 2.407.672c.388.344.593.837.593 1.486V22h2v-.526c0-1.097-.366-2.183-1.264-2.981-.884-.786-2.153-1.177-3.736-1.177s-2.852.391-3.736 1.177C8.366 19.29 8 20.377 8 21.473V22h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgCalendarTeam as CalendarTeam };
